(function() {
	var buttons = document.querySelectorAll('.copy-btn');
	for (var i = 0; i < buttons.length; i++) {
		buttons[i].addEventListener('click', function(e) {
			e.preventDefault();
			var $this = e.target;

			var target = $this.getAttribute('data-target');

			if (!target) return;

			var $target = document.querySelector(target);

			if (!$target) return;

			// Select target
			$target.select();

			// Execute copy command
			document.execCommand('copy');

			// Add class to indicate link has been copied
			$this.classList.add('copied');

			// Remove class after timeout
			setTimeout(function() {
				$this.classList.remove('copied');
			}, 2000);
		});
	}
})();

(function() {
	var inputs = document.querySelectorAll('.copy-input');

	for (var i = 0;i < inputs.length;i++) {
		inputs[i].addEventListener('click', function(e) {
			e.preventDefault();

			// Select self
			e.target.select();
		});
	}
})();